import { Outlet } from 'react-router-dom'
import EnhancedErrorBoundary from '@/components/error/error-boundary'

export function AuthLayout() {
  return (
    <EnhancedErrorBoundary>
      <Outlet />
    </EnhancedErrorBoundary>
  )
}
